<template>
    <div>
        <scale 
        :model_score="keyboard_score" 
        :model_comment="keyboard_comment" 
        :section="section" 
        :contents="contents"
        :title="title"></scale>
    </div>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            keyboard_score: [],
            keyboard_comment:[],
            title:"Keyboard and Mouse",
            contents:[
                {
                    question:"When typing, are the employee’s wrist in neutral position (straight on home row & keyboard centered in front of user)?",
                    parts: ['Wrist']
                },
                {
                    question:"Is there a padded wrist rest?",
                    parts: ['Wrist']
                },
                {
                    question:"Are elbows maintained at 80-90 degrees?",
                    parts: ['Elbow']
                },
                {
                    question:"Is the mouse beside the keyboard at the same level as the keyboard?",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.keyboard_score.length; x++){
                if(this.keyboard_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.keyboard_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.keyboard_score.length != this.contents.length || this.keyboard_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            // let na = this.getTotalNa();
            db.collection('forms').doc(id).update(
                {
                    keyboard_score: this.keyboard_score,
                    keyboard_comment: this.keyboard_comment,
                    keyboard_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.keyboard_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

